export default __webpack_public_path__ + "static/media/SWT1620.34I-38328_-22531_0.b936effc.jpg";